import React, {useState} from "react";
import userACL from '../../../store/access'
import Layout from "../../companyCreationLayout/components/layout";
import LayoutWithInstruction from "../../companyCreationLayout/components/layoutWithInstruction";
import { positions, Provider as AlertProvider ,useAlert,transitions } from "react-alert";
import CustomAlertTemplate from '../../companyCreationLayout/components/customAlertTemplate';


const MainContent = (props) => {
  let [layout,setLayout] = useState(1);
  const [curState,setCurState] = useState(1);
  let [onbackClick,setonbackClick] = useState(false);
  let [selectedCountry,setselectedCountry] = useState("India");
  let [selectedCountryId,setselectedCountryId] = useState("101");
  let [ispwEncrypted,setispwEncrypted] = useState(false);
  const options = {
    position: positions.BOTTOM_CENTER,
    timeout: 5000,
    offset: '30px',
    transition: transitions.FADE
  };
  
  return <AlertProvider template={CustomAlertTemplate} {...options}>
       {
        layout == 1 ? 
        <Layout
          setLayout={setLayout}
          curState={curState}
          setCurState={setCurState}
          onbackClick={onbackClick}
          setonbackClick={setonbackClick}
          selectedCountry={selectedCountry}
          setselectedCountry={setselectedCountry}
          selectedCountryId={selectedCountryId}
          setselectedCountryId={setselectedCountryId}
          ispwEncrypted={ispwEncrypted}
          setispwEncrypted={setispwEncrypted}
        /> : 
        <LayoutWithInstruction
          setLayout={setLayout}
          curState={curState}
          setCurState={setCurState}
          onbackClick={onbackClick}
          setonbackClick={setonbackClick}
          selectedCountry={selectedCountry}
          setselectedCountry={setselectedCountry}
          selectedCountryId={selectedCountryId}
          setselectedCountryId={setselectedCountryId}
          ispwEncrypted={ispwEncrypted}
          setispwEncrypted={setispwEncrypted}
        />
        }
        </AlertProvider>
}

export default MainContent;
